import AuthRegistration from "./AuthRegistration";

export default AuthRegistration;
